import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import Category from "./Category";

const PREFIX = 'Downloads';

const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    height: "auto !important",
    width: "95% !important",
    padding: "1em",
  },

  [`& .${classes.header}`]: {
    textTransform: "capitalize",
    fontWeight: "bold",
    display: "block",
    marginBottom: "1em",
  }
}));

const Downloads = ({ downloads }) => {

  const [downloadObj, setDownloadObj] = useState({});

  const init = async () => {
    const _downloadObj = {};
    downloads.map((download) => {
      if (!_downloadObj[download.category]) {
        _downloadObj[download.category] = {};
      }
      if (!_downloadObj[download.category][download.subcategory]) {
        _downloadObj[download.category][download.subcategory] = [];
      }
      _downloadObj[download.category][download.subcategory].push({
        name: download.name,
        icon: download.icon,
        link: download.link,
        file: download.file,
        meta: download.meta,
      });
      return null;
    });
    setDownloadObj({ ..._downloadObj });
  };

  useEffect(() => {
    if (downloads) {
      init();
    }
  }, []);

  return (
    <Root className={classes.root}>
		<div>
	      <span className={classes.header}>Downloads</span>
	      {Object.keys(downloadObj).map((key) => {
	        return <Category category={key} subcategories={downloadObj[key]} />;
	      })}
		</div>
    </Root>
  );
};

export default Downloads;
